import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { StorageService } from '../../../../Common/services/storage.service';
import { UserLogin } from '../../../../Common/models/user.login';
import { ProjectService } from '../../../services/project.service';
import { SalesPlanVm, GinfoSpKeyDatesVm, ProjectApproval, SalesPlanImagesVm, SalesPlanImageFilesVm } from '../../../models/salesplan-vm';
import { PurposeEnum } from '../../../enums/purpose-enum';
import { ProductListManualVm, ProjectFilesVm, ProjectStatus, InstallationProductResultDto, StoreValidationRequestVM, ReviewLog } from '../../../models/project-vm';
import { RefTypeEnum } from '../../../enums/ref-type-enum';
import { ToastrService } from 'ngx-toastr';
import { ProjectApprovalStage, RoleKey, WizardStatus, RoleName, EmailPurpose } from '../../../../Common/Constants/common.constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralInfoSalesplanDetailsComponent } from '../ginfo-salesplan-details/ginfo-salesplan-details.component';
import { CommonStoreListComponent } from '../../common/common-store-list/common-store-list.component';
import { CommonProductsListComponent } from '../../common/common-products-list/common-products-list.component';
import { CommonProductListManualComponent } from '../../common/common-product-list-manual/common-product-list-manual.component';
import { ProjectConstants } from '../../../constants/component-messages';
import { CommonApprovalComponent } from '../../common-approval/common-approval.component';
import { MessageService } from '../../../services/message.service';
import { v4 as uuidv4 } from 'uuid';
import { ConfirmationService } from 'primeng/api';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { ErrorLoggerService } from '../../../../shared/services/error-logger.service';
import { CustomEncodeDecodeService } from '../../../../Common/services/custom-encode-decode.service';
import { ApprovalConstants, NewlyAddedProductsConstants } from '../../../../Common/Constants/data';
import { DataShareService } from '../../../services/data-share.service';
import { MasterService } from '../../../../administration/services/master.service';
import { Product } from '../../../../administration/models/models-vm';
import { GinfoSpKeyDatesComponent } from '../ginfo-salesplan-keydates/ginfo-salesplan-keydates.component';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { EmailRequestDto, ProjectDto } from '../../../../Common/models/emailrequestdto';
import { EmailNotificationService } from '../../../../Common/services/email-notification.service';
import { finalize } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-addeditsalesplan',
  templateUrl: './addeditsalesplan.component.html',
  //styleUrl: './addproject.component.css',
  styleUrls: [
    './addeditsalesplan.component.css'
    , './../../../../../assets/css/new-project.css'
    , './../../../../../assets/css/steps.css'
  ]
})
export class AddEditSalesPlanComponent implements OnInit {
  selectedNewProductCategoryId?: number | null | undefined;
  showCommonProductsListManualComponent: boolean = false;
  displayBubbleStatus: any = {
    Approval_step: ''
    , ExecutionCompleted_step: ''
    , ExecutionStarted_step: ''
    , Initiated_step: ''
    , PWRLinked_step: ''
    , Verified_step: ''
  };

  vendorId?: string;
  storedVendor: any;
  categoryId?: string;
  public categoryList: any[] = [];
  public userCategoryList: any[] = [];
  selectedCategories: any[] = [];
  previousSelectedCategories: any[] = [];
  refType: RefTypeEnum = RefTypeEnum.Sales;
  purposeStore: PurposeEnum = PurposeEnum.Stores;
  purposeProducts: PurposeEnum = PurposeEnum.Products;
  storedVendorId: any;
  sreSPOCID: number = 0;
  selectedCategory: number = 0;
  userDisplayName: string | null = "";
  orgID: number = 0;
  loggedInUserID: number = 0;
  headerId: number = 0;
  salesplanId: number = 0;
  catgId: number = 0;
  initiatedStatusClass: string = WizardStatus.ONPROGRESS;
  approvedStatusClass: string = "";
  pwrLinkedStatusClass: string = "";
  completedStatusClass: string = "";
  approvalStatus: string = "Pending";
  enablePWR: boolean = false;
  activeTab: string = 'generalInfo';
  uInfo: UserLogin | null | undefined;
  productItems: any[] = [];
  storeFile: File | null | undefined;
  productFile: File | null | undefined;
  salesplanModel: SalesPlanVm = new SalesPlanVm();
  disableAfterReview: boolean = false;
  disableAll: boolean = false;
  hasProductItems: boolean = false;
  productReviewedDate: Date | null | undefined;
  productReviewedBy: string = '';
  inActiveStores: any[] = [];

  projectTitleDisplay: string = ProjectConstants.SALESPLAN_TITLE;
  orgProductsList: Product[] = [];
  allCategories: number[] = [];
  reciveCoomunication: any = {};
  @ViewChild('saveDiv') saveDiv!: ElementRef;
  @ViewChild(GeneralInfoSalesplanDetailsComponent) childComponent: GeneralInfoSalesplanDetailsComponent | undefined;
  @ViewChild(CommonStoreListComponent) storeListComponent: CommonStoreListComponent | undefined;
  @ViewChild(CommonProductsListComponent) productsListComponent: CommonProductsListComponent | undefined;
  @ViewChild(CommonProductListManualComponent) productsListManualComponent: CommonProductListManualComponent | undefined;
  @ViewChild(CommonApprovalComponent) commonApprovalComponent: CommonApprovalComponent | undefined;
  @ViewChild(GinfoSpKeyDatesComponent) ginfoSpKeyDatesComponent: GinfoSpKeyDatesComponent | undefined;
  catgIds: number[] = [];

  public isITAdmin: boolean = false;
  public isSRETeam: boolean = false;
  public isSRESupport: boolean = false;
  public isCustomerSupportTeam: boolean = false;
  hasUnsaved: boolean = false;

  logos: any[] = [];
  showModalPopup: boolean = false;
  selectedImages: any[] = [];

  clonedProjectTitle: string = '';
  salesplanOriginal: SalesPlanVm = new SalesPlanVm();

  storesByStates: any[] = [];
  existingStoreNumbers?: string | null;
  validatedStoreNumbers?: string | null;
  selectedStoresByStates: any[] = [];

  showModalPopupForStates: boolean = false;
  isNotifiedForStoreIdentificaion: boolean = false;
  selectedIdentifiedStoreNumbers?: string = '';
  storeNumbersToIdentify?: string = '';

  constructor(private storageService: StorageService, private projectService: ProjectService,
    private toastr: ToastrService, private ngxService: NgxUiLoaderService,
    private route: ActivatedRoute,
    private msgService: MessageService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private userRoleService: UserRoleServiceService,
    private errorLogService: ErrorLoggerService,
    private encodeDecodeService: CustomEncodeDecodeService,
    private renderer: Renderer2, private dataShareService: DataShareService,
    private masterService: MasterService,
    private unsavedChangesService: UnsavedChangesService,
    private datePipe: DatePipe,
    private emailService: EmailNotificationService) { }

  async ngOnInit() {
    this.unsavedChangesService.getUnsavedChanges$().subscribe((hasUnsaved) => {
      this.hasUnsaved = hasUnsaved;
    });
    if (this.userRoleService.role?.roleKey == RoleKey.ITAdmin) {
      //alert("Un authorized access");
      this.router.navigate(['/unauthorized']);
      return;
    }

    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      let uInfoForRoles = JSON.parse(atob(encodedVal));
      let userRoleInfo: UserLogin = uInfoForRoles!;
      this.isITAdmin = userRoleInfo.roles.some((a: any) => a.roleName == RoleName.ITAdmin);
      this.isSRETeam = userRoleInfo.roles.some((a: any) => (a.roleName == RoleName.SREAdmin || a.roleName == RoleName.SRESupport) && (a.write == true));
      this.isSRESupport = userRoleInfo.roles.some((a: any) => (a.roleName == RoleName.SRESupport) && (a.write == false));
      this.isCustomerSupportTeam = userRoleInfo.roles.some((a: any) => a.roleName == RoleName.CustomerTeam);
    }

    await this.loadProducts();
    this.getUserRoleInfo();
    this.initiatedStatusClass = "";
    //this.setSalesplanWizardStatus("", null);

    this.getStoresByStates();

    this.uInfo = this.storageService.getItem<UserLogin>("UserInfo");
    this.route.params.subscribe(async params => {
      this.salesplanId = this.encodeDecodeService.decodeToInt(params['id']); // Use the ID in your component logic
      //this.catgId = this.encodeDecodeService.decodeToInt(params['catId']);
      // Decodes the string
      const catIdString = this.encodeDecodeService.decode(params['catId']);
      // Splits the string and converts each value to an integer
      if (catIdString) {
        this.catgIds = catIdString.split(',').map((id: any) => parseInt(id, 10));
      }
      if (this.salesplanId == 0) {
        if (this.userRoleService.role?.write == false) {
          //("Un authorized access");
          this.router.navigate(['/unauthorized']);
          return;
        }
      }
      if (!!this.salesplanId && this.salesplanId > 0) {
        if (this.userRoleService.role?.write === false) {
          this.disableAll = true;
        } else {
          if (this.userRoleService.role?.roleID == 4 && this.catgIds && this.catgIds && this.catgIds.length > 0) {
            this.categoryList = this.uInfo!.categories;
            this.categoryList = this.categoryList.map((x: any) => ({ 'label': x.categoryName, 'value': x.categoryID }));
            this.selectedCategories = this.categoryList.map(a => a.value);
            // this.disableAll= this.userRoleService.disableField(this.catgId);
            this.disableAll = this.userRoleService.disableField(this.catgIds);
          }
          //this.projectModel.generalInfo.projectDetails.categoryId= this.catgId;
        }

        this.ngxService.start();
        await this.loadSalesplanDetails(this.salesplanId);
        //this.ngxService.stop();
      }
      else {
        this.salesplanId = 0;
        this.userDisplayName = this.storageService.getItem<string>("UserDisplayName");
      }
    });

    this.salesplanModel.projectStatus = new ProjectStatus();
    this.salesplanModel.projectStatus.changedBy = this.loggedInUserID;
    this.salesplanModel.projectStatus.changedDate = new Date();
    this.salesplanModel.projectStatus.isApproved = false;
    this.salesplanModel.projectStatus.refID = 0;
    this.salesplanModel.projectStatus.statusID = 1;
    this.salesplanModel.projectStatus.type = RefTypeEnum.Sales;
    this.activeTab = 'generalInfo';

    this.projectService.getAllLogos().subscribe(data => {
      this.logos = data;
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.unsavedChangesService.hasUnsaved) {
      $event.returnValue = 'You have unsaved changes! Are you sure you want to leave?';
    }
  }

  canDeactivate(): boolean {
    if (this.unsavedChangesService.hasUnsaved) {
      return confirm('You have unsaved changes! Are you sure you want to discard them?');
    }
    return true;
  }

  ngOnDestroy() {
    this.unsavedChangesService.setUnsavedChanges(false); // Reset when the component is destroyed
  }

  onAnyFieldValueChange(e: boolean) {
    if (e) {
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  getUserRoleInfo() {
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      let userRoleInfo: UserLogin = JSON.parse(atob(encodedVal));
      this.storedVendor = this.storageService.getItem<any>("selectedVendor");
      this.vendorId = this.storedVendor.vendorID;
      this.orgID = userRoleInfo.orgID;
      this.loggedInUserID = userRoleInfo.userID;
      //userRoleInfo.categories = userRoleInfo.categories ?.filter(v => v.vendorID == this.vendorId);

      this.categoryList = this.userRoleService.role?.roleID == 4 ? userRoleInfo.userCategory : userRoleInfo.categories;
      this.categoryList = this.categoryList.map((x: any) => ({ 'label': x.categoryName, 'value': x.categoryID }));
      //this.selectedCategories = this.categoryList.map(a=>a.value);
    }
  }

  onFileChanged(e: any) {
    
    if (e.purpose == PurposeEnum.Stores) {
      this.salesplanModel.generalInfo.storeList = e.selFile;
    }
    else if (e.purpose == PurposeEnum.Products) {
      this.salesplanModel.products = e.selFile;
      if (e.selFile == null) {
        this.hasProductItems = false;
      }
      else {
        this.hasProductItems = true;
      }
    }
  }

  onStoreFileChanged(e: any) {
    this.storeFile = e.file;
    if (e.isValidatedStores) {
      this.validatedStoreNumbers = e.validatedStores;
    }
  }

  onProductFileChanged(e: any) {
    this.productFile = e.file;
  }

  onKeyDatesChanged(e: GinfoSpKeyDatesVm) {
    this.salesplanModel.generalInfo.keyDates = e;
  }

  onImagesChanged(e: SalesPlanImagesVm) {
    this.salesplanModel.images = e;
  }

  onSelectedCategory_bkp() {
    this.salesplanModel.category = this.selectedCategory;
  }

  onSelectedCategory(selectedValues: number[]) {
    const unselected = this.previousSelectedCategories.filter(item => !selectedValues.includes(item));
    if (this.salesplanId > 0) {
      if (unselected.length > 0) {
        this.categorySelectionConfirmation(selectedValues, unselected);
      } else {
        this.previousSelectedCategories = [...selectedValues];
      }
    }
    this.salesplanModel.selectedCategories = selectedValues;
    this.unsavedChangesService.setUnsavedChanges(true);
    this.getProductsByCategories();
  }

  async validateStores(): Promise<boolean> {
    let inputMOdel: StoreValidationRequestVM = new StoreValidationRequestVM();

    if (this.salesplanModel!.generalInfo.storeList! != null) {
      inputMOdel.storeNubersList = this.salesplanModel!.generalInfo.storeList!.storeNumbers!;
    }
    else if (this.salesplanModel!.generalInfo.storeListManual! != null) {
      inputMOdel.storeNubersList = this.salesplanModel!.generalInfo.storeListManual!.storeNumbers!;
    }

    if (inputMOdel.storeNubersList != null && inputMOdel.storeNubersList.length > 0) {

      let allHawaiiStore = this.selectedStoresByStates.map(x => x.storeNumber).join(',');

      const hasStoreNumbersChanged = this.isAnyChangesOnStoreNumbers(this.existingStoreNumbers!, inputMOdel.storeNubersList!);

      if (hasStoreNumbersChanged) {
        const hasStoreNumbersPendingValidation = this.isAnyChangesOnStoreNumbers(this.validatedStoreNumbers!, inputMOdel.storeNubersList!);

        if (hasStoreNumbersPendingValidation) {
          this.msgService.htmlError(ProjectConstants.STORE_VALIDATION_PENDING);
          return false;
        }

        let storeToIdentify = this.getStoresToIdentify(allHawaiiStore, inputMOdel.storeNubersList, this.salesplanModel.identifiedStores!);
        
        //if (!this.isNotifiedForStoreIdentificaion || storeToIdentify !== '') {
        if (storeToIdentify !== '' && this.salesplanModel.generalInfo.salesplanDetails.salesplanId! > 0) {
          this.msgService.htmlError(ProjectConstants.STORE_NOTIFICATION_PENDING);
          return false;
        }
        else if (storeToIdentify !== '' && (this.salesplanModel.generalInfo.salesplanDetails.salesplanId! === undefined || 
          this.salesplanModel.generalInfo.salesplanDetails.salesplanId! === 0)) {
          this.salesplanModel.storesToIdentify = storeToIdentify;
          return true;
        }
        else {
          this.storeListComponent!.errorDetails = "";
          return true; // Validation succeeded
        }
      } else {
        this.storeListComponent!.errorDetails = "";
        return true;
      }
    } else {
      // No stores to validate
      this.storeListComponent!.errorDetails = "";
      return true; // No validation needed, proceed with saving
    }

    // if (inputMOdel.storeNubersList != null
    //   && inputMOdel.storeNubersList != undefined
    //   && inputMOdel.storeNubersList.length > 0
    // ) {
    //   this.ngxService.start();
    //   try {
    //     const result = await this.projectService.validateStoreNumbers(inputMOdel).toPromise(); // Convert observable to promise
    //     this.inActiveStores = [...result.inActiveStores, ...result.inValidStores];
    //     this.storesByStates = result.storesByStates;

    //     if (this.inActiveStores.length > 0) {
    //       this.msgService.htmlError("There are Invalid / Inactive stores please correct and try to save again.");
    //       const storeIdsString = this.inActiveStores.map(store => store.storeNumber).join(',');

    //       this.storeListComponent!.errorDetails = `There are Invalid / Inactive stores. Please correct and try again. Store# are: ${storeIdsString}`;
    //       return false; // Validation failed
    //     } else {
    //       this.storeListComponent!.errorDetails = "";
    //       return true; // Validation succeeded
    //     }
    //   } catch (error) {
    //     console.error('Error during store validation:', error);
    //     return false; // Error occurred, treat as failed validation
    //   } finally {
    //     this.ngxService.stop(); // Ensure loading is stopped
    //   }
    // }
    // else {
    //   this.storeListComponent!.errorDetails = "";
    //   return true;
    // }
  }

  async validateSalesPlanData(isreadyForReview: boolean = false): Promise<boolean> {
    let validMsgs: any[] = [];
    let pwrNoValid: boolean = false;
    let pwrDateValid: boolean = false;

    if (this.salesplanModel.selectedCategories && this.salesplanModel.selectedCategories.length == 0) {
      validMsgs.push(ProjectConstants.GENERALINFO_KEY_CATEGORY_REQUIRED);
    }

    this.childComponent?.validateFields()!.forEach(item => {
      validMsgs.push(item);
    });

    if (validMsgs.length! > 0) {
      const combinedMessages = validMsgs.join('<br/>');
      this.msgService.htmlError(combinedMessages);
      return false;
    }

    const isValidStores = await this.validateStores();
    if (!isValidStores) {
      return false;
    }

    if (this.salesplanModel.isProductManual === true) {
      this.salesplanModel.products = null;
    } else {
      this.salesplanModel.productsManual = null;
    }

    if (this.salesplanModel.generalInfo.salesplanDetails.pwrNumber != null
      && this.salesplanModel.generalInfo.salesplanDetails.pwrNumber != undefined
      && this.salesplanModel.generalInfo.salesplanDetails.pwrNumber.length > 0
    ) {
      pwrNoValid = true;
    }

    if (this.salesplanModel.generalInfo.keyDates.pwrDateStr != null
      && this.salesplanModel.generalInfo.keyDates.pwrDateStr != undefined
      && this.salesplanModel.generalInfo.keyDates.pwrDateStr != 'Invalid date'
      && this.salesplanModel.generalInfo.keyDates.pwrDateStr.length > 0
    ) {
      pwrDateValid = true;
    }
    // if (this.salesplanModel.category <= 0) {
    //   validMsgs.push("Category is required");
    // }
    ///New product validations
    if (this.salesplanModel.productsManual &&
      this.salesplanModel.productsManual.some(product => product.isManuallyAddedNewProduct === true
        && product.productID == 0 && product.isItRemove == false) &&
      this.selectedNewProductCategoryId === undefined
    ) {

      validMsgs.push(NewlyAddedProductsConstants.Product_Category);
    }
    if (isreadyForReview && this.salesplanModel.productsManual) {
      const result = this.hasEmptyRequiredPropertiesForNewProduct(this.salesplanModel.productsManual);
      if (result) {
        validMsgs.push(NewlyAddedProductsConstants.Product_Fields);
      }
    }
    // Check newly added custom product Itemnumber validations
    if (isreadyForReview && this.salesplanModel.productsManual) {
      const result = this.getAddProjectResult(this.salesplanModel.productsManual); // Directly assign the result

      if (result.length > 0) {
        result.forEach((item: any) => {
          validMsgs.push(`Product Description ${item.productDesc} Item Number ${item.itemNumber} already exists`);
        });


      }
    }

    if (validMsgs.length! > 0) {
      const combinedMessages = validMsgs.join('<br/>');
      this.msgService.htmlError(combinedMessages);
      return false;
    }
    else {
      return true;
    }
  }

  async saveSalesplan() {
    this.unsavedChangesService.setUnsavedChanges(false);
    let isValidSalesPlanData = await this.validateSalesPlanData();
    this.unsavedChangesService.setUnsavedChanges(false);

    if (isValidSalesPlanData) {

      this.assignCategoryToProducts(this.salesplanModel);

      this.updateSalesplanModel();

      ///Providing confirmation for the category selection is not changeable once the project is created 
      /// and we are showing it only for the first time project create.
      if (this.salesplanModel.salesplanId > 0) {
        this.finalSalesPlanSave();
      }
      else {
        this.finalSalesPlanSave();
      }

    }
  }

  finalSalesPlanSave(isCloned: boolean = false) {
    this.ngxService.start();

    this.projectService.addEditSalesplanDetails(this.salesplanModel).subscribe({
      next: (response: any) => {
        this.ngxService.stop();

        if (response.success) {

          if (response.status == 1) {
            let inActiveStores = [...response.message.inActiveStores, ...response.message.inValidStores];

            // Extract the storeId from each store and join them with a comma
            const storeIdsString = response.message.map((store: { storeNumber: any; }) => store.storeNumber).join(',');
            const msg = `The following store IDs (${storeIdsString}) are inactive or invalid and have been excluded from the list during the saving process.`;
            
            this.msgService.htmlError("There are Invalid / Inactive stores please correct and try to save agian.");

            this.storeListComponent!.errorDetails = `There are Invalid / Inactive stores please correct and try to save agian. Store# are: ${storeIdsString}`;
          }
          else {
            if (isCloned) {
              this.msgService.htmlSuccess(ProjectConstants.SALESPLAN_CLONE_SUCCESS);
            }
            else {
              this.msgService.htmlSuccess(ProjectConstants.SALESPLAN_SAVE_SUCCESS);
            }

            this.selectedNewProductCategoryId = undefined;
            this.salesplanId = response.salesplanId;
            this.loadSalesplanDetails(response.salesplanId);
            if (this.salesplanModel.projectStatus!.statusID! > 1) {
              // this.loadSalesplanDetails(this.salesplanId!);
            }
            else {

              //this.router.navigate(['/projectintake/editsalesplan', this.salesplanId]);
              this.router.navigate(['/projectintake/editsalesplan', this.encodeDecodeService.encode(this.salesplanId)]);
              // this.dataShareService.emitDataBetweenProducts('');
            }
          }
        }
        else {
          let validMsgs: string[] = [];

          if (response.installationProductResultDto !== null && response.installationProductResultDto.length > 0) {
            response.installationProductResultDto.forEach((item: any) => {
              validMsgs.push(`Product Description ${item.productDesc} Item Number ${item.itemNumber} already exists`);
            });
            const combinedMessages = validMsgs.join('<br/>');
            this.msgService.htmlError(combinedMessages);
          } else {
            //this.toastr.error("Unexpected error occurred in save process");
          }

        }
      },
      error: (error) => {
        this.errorLogService.logError(error, 'saveSalesplan');
        this.ngxService.stop();
      },
    });
  }

  categorySelectionConfirmation(selected: any, unselected: any) {
    this.confirmationService.confirm({
      header: ' ',
      icon: 'pi pi-exclamation-triangle',
      message: "Removing the category will also delete any associated products. Do you want to proceed?",
      accept: () => {

        //this.finalSaveProject();
        this.selectedCategories = [...selected];
        this.deleteProductByCategory(unselected);


      },
      reject: () => {
        this.selectedCategories = [...this.previousSelectedCategories];
        return;
      }
    })
  }

  updateSalesplanModel() {
    this.salesplanModel.orgID = this.orgID;
    this.salesplanModel.vendorId
      = this.storageService.getItem<any>("selectedVendor").vendorID;

    if (this.headerId == 0 && this.salesplanId == 0) {
      this.salesplanModel.requestor = this.loggedInUserID;
      this.salesplanModel.projectStatus = {
        statusID: 1,
        changedBy: this.salesplanModel.requestor,
        type: RefTypeEnum.Sales,
        isApproved: false
      }
    } else
      if (this.salesplanModel.projectStatus!.statusID == 2
        && this.salesplanModel.projectApproval?.isApproveClicked) {
        this.salesplanModel.projectStatus!.projectStatusID = 0;
        this.salesplanModel.projectStatus!.changedBy = this.loggedInUserID;
        this.salesplanModel.projectStatus!.changedDate = new Date();
        this.salesplanModel.projectStatus!.isApproved = false;
        this.salesplanModel.projectStatus!.refID = this.salesplanId!;
        this.salesplanModel.projectStatus!.statusID = 3;
        this.salesplanModel.projectStatus!.type = RefTypeEnum.Sales;
      }
  }

  enableDisableControl(approvalStage: any) {
    if (approvalStage == ProjectApprovalStage.REQUESTAPPROVAL && this.userRoleService.role?.roleKey == RoleKey.CustomerTeam) {
      this.disableAll = false;
    } else if (approvalStage == ProjectApprovalStage.ACTIONREQUIRED && this.userRoleService.role?.roleKey == RoleKey.CustomerTeam) {
      if (!this.disableAll) {
        this.disableAll = false;
      }
    } else if (approvalStage == ProjectApprovalStage.APPROVED) {
      this.disableAll = true;
    }
    else if (approvalStage == ProjectApprovalStage.LOCKED) {
      this.disableAll = true;
    }
    else if (approvalStage == ProjectApprovalStage.UNLOCKED && this.userRoleService.role?.roleKey == RoleKey.CustomerTeam) {
      this.disableAll = true;
    }
    else if (approvalStage == ProjectApprovalStage.UNLOCKED && this.userRoleService.role?.roleKey == RoleKey.SREAdmin) {
      this.disableAll = false;
    }
    else if (approvalStage == ProjectApprovalStage.UNLOCKED && this.userRoleService.role?.roleKey == RoleKey.SRESupport) {
      this.disableAll = false;
      if (this.userRoleService.role?.write == false) {
        this.disableAll = true;
      }

    }
    if (this.disableAll && this.userRoleService.role?.roleKey !== RoleKey.SREAdmin) { //disable save for SRE support read role
      if (this.userRoleService.role?.roleKey == RoleKey.SRESupport) {
        if (this.userRoleService.role?.write !== true) {
          const divElement = this.saveDiv.nativeElement;
          if (divElement) {
            divElement.style.pointerEvents = 'none'; // Disable mouse interactions
            divElement.style.opacity = '0.5'; // Optional: make the div look disabled
          }

        }
      }
    }
    if (this.disableAll && this.userRoleService.role?.roleKey == RoleKey.CustomerTeam) { //disable save for customer team
      const divElement = this.saveDiv.nativeElement;
      if (divElement) {
        divElement.style.pointerEvents = 'none'; // Disable mouse interactions
        divElement.style.opacity = '0.5'; // Optional: make the div look disabled
      }
    }
  }

  async loadSalesplanDetails(salesplanId: number) {
    //this.ngxService.start();
    await this.projectService.getSalesplanDetails(salesplanId).subscribe({
      next: async (data: any) => {
        this.selectedCategories = data.selectedCategories;
        this.salesplanModel = data;

        // Hold a deep clone separately for cloning purpose (immutable reference)
        this.salesplanOriginal = JSON.parse(JSON.stringify(data));

        this.headerId = this.salesplanModel.headerId;
        this.selectedCategory = this.salesplanModel.category;
        this.userDisplayName = this.salesplanModel.requestorName;
        if (this.selectedCategories.length > 0) {
          this.previousSelectedCategories = [...this.selectedCategories];
          this.getProductsByCategories();
        }

        if (this.salesplanModel!.generalInfo.storeList! != null) {
          this.existingStoreNumbers = this.salesplanModel!.generalInfo.storeList!.storeNumbers!;
          this.validatedStoreNumbers = this.salesplanModel!.generalInfo.storeList!.storeNumbers!;
        }
        else if (this.salesplanModel!.generalInfo.storeListManual! != null) {
          this.existingStoreNumbers = this.salesplanModel!.generalInfo.storeListManual!.storeNumbers!;
          this.validatedStoreNumbers = this.salesplanModel!.generalInfo.storeListManual!.storeNumbers!;
        }
        this.selectedIdentifiedStoreNumbers = this.salesplanModel.identifiedStores!;

        let productSelection = false;
        let productSelectionManual = false;
        if (this.salesplanModel.products != null) {
          productSelection = true;
          productSelectionManual = false;
          //this.productsListComponent?.loadDefaultSelection(true);
        }
        if (this.salesplanModel.projectApproval) {
          let approvalStage = this.salesplanModel.projectApproval.approvalStage;
          this.enableDisableControl(approvalStage);

        }

        if (this.salesplanModel.productsManual != null
          && this.salesplanModel.productsManual.length > 0
        ) {
          productSelection = false;
          productSelectionManual = true;
          //this.productsListComponent?.loadDefaultSelection(true);
        }

        if (productSelection) {
          this.productsListComponent?.loadDefaultSelection(true);
        }
        else {
          //By Default, product selection should be manual   
          this.productsListManualComponent?.loadDefaultSelection(true);
        }

        // if (productSelectionManual) {
        //   this.productsListManualComponent?.loadDefaultSelection(true);
        // }
        // else {
        //   this.productsListComponent?.loadDefaultSelection(true);
        // }

        if ((this.salesplanModel.products != null) || (this.salesplanModel.productsManual != null
          && this.salesplanModel.productsManual.length > 0)) {
          this.hasProductItems = true;
        }
        else {
          this.hasProductItems = false;
        }

        if (this.hasProductItems && this.salesplanModel.productsReviewLog != null && this.salesplanModel.productsReviewLog.length > 0) {
          this.productReviewedBy = this.salesplanModel.productsReviewLog[0].reviewedBy!;
          this.productReviewedDate = this.salesplanModel.productsReviewLog[0].reviewedOn;
        }

        // this.storeListComponent!.downloadLink
        //   = `Stores_${this.salesplanModel.generalInfo.salesplanDetails.projectTitle}.xlsx`;

        // this.productsListComponent!.downloadLink
        //   = `Products_${this.salesplanModel.generalInfo.salesplanDetails.projectTitle}.xlsx`;

        // this.productsListManualComponent!.downloadLink
        //   = `Products_${this.salesplanModel.generalInfo.salesplanDetails.projectTitle}.xlsx`;

        if (this.storeListComponent! != null
          && this.storeListComponent! != undefined
        ) {
          this.storeListComponent!.downloadLink
            = `Stores_${this.salesplanModel.generalInfo.salesplanDetails.projectTitle}.xlsx`;
        }

        if (this.productsListComponent! != null
          && this.productsListComponent! != undefined
        ) {
          this.productsListComponent!.downloadLink
            = `Products_${this.salesplanModel.generalInfo.salesplanDetails.projectTitle}}.xlsx`;
        }

        if (this.productsListManualComponent! != null
          && this.productsListManualComponent! != undefined
        ) {
          this.productsListManualComponent!.downloadLink
            = `${this.salesplanModel.generalInfo.salesplanDetails.projectTitle}}_Products.xlsx`;
        }

        this.enablePWR
          = ((this.salesplanModel.projectStatus!.statusID! > 1
            && (this.salesplanModel.projectApproval?.approvalStage == ApprovalConstants.Approval_Approved
              || this.salesplanModel.projectApproval?.approvalStage == ApprovalConstants.Approval_LOCKED
              || this.salesplanModel.projectApproval?.approvalStage == ApprovalConstants.Approval_UNLOCKED
            ))
            || (this.salesplanModel.projectStatus!.statusID! > 2)) ?
            (this.uInfo!.roles[0].roleID == 2 || (this.uInfo!.roles[0].roleID == 3 && this.uInfo!.roles[0].write == true) ? true : false) :
            false;
        // if((this.salesplanModel.projectStatus!.statusID! ==2
        //   && this.salesplanModel.projectApproval?.isReviewClicked
        //   && this.salesplanModel.projectApproval?.isApproveClicked == false)
        //   ||(this.salesplanModel.projectStatus!.statusID! >=2
        //     && this.salesplanModel.projectApproval?.isReviewClicked == false
        //     && this.salesplanModel.projectApproval?.isApproveClicked == true)
        // )
        // {
        //   if(this.uInfo!=null && this.uInfo !=undefined)
        //   {
        //     if(this.uInfo.roles != null
        //       && this.uInfo.roles != undefined
        //       && this.uInfo.roles.length > 0
        //     )
        //     {
        //       if(this.uInfo.roles[0].roleID == 2)
        //       {
        //         this.disableAfterReview = true;
        //       }
        //       else
        //       {
        //         this.disableAfterReview = true;
        //       }
        //     }
        //   }
        // }
        // else
        // {
        //   this.disableAfterReview = false;
        // }

        if ((this.salesplanModel.projectStatus!.statusID! == 2
          && this.salesplanModel.projectApproval?.isReviewClicked
          && this.salesplanModel.projectApproval?.isApproveClicked == false)
        ) {
          if (await this.userRoleService.canEdit()) {
            this.disableAfterReview = false;
          }
          else {
            this.disableAfterReview = true;;
          }
        }
        else {
          if ((this.salesplanModel.projectStatus!.statusID! >= 2
            && this.salesplanModel.projectApproval?.isReviewClicked == false
            && this.salesplanModel.projectApproval?.isApproveClicked == true)
          ) {
            if (await this.userRoleService.canscreenEditAfterApprove()) {
              this.disableAfterReview = false;
            }
            else {
              this.disableAfterReview = true;;
            }
          }
          else {
            this.disableAfterReview = false;
          }
        }

        // if (this.salesplanModel.projectApproval ?.approvedBy! > 0 && this.salesplanModel.projectApproval ?.approvedDate! != null) {
        //   this.approvalStatus = "Approved";
        // }
        // else {
        //   this.salesplanModel.projectApproval = new ProjectApproval();
        // }

        this.projectTitleDisplay = this.salesplanModel.generalInfo.salesplanDetails.projectTitle;

        let statusBUbble = this.commonApprovalComponent?.setWizardStatus(
          this.salesplanModel.projectStatus!, this.salesplanModel.projectApproval!
        );
        this.bubbleStatusUpdate(statusBUbble);
        this.showCommonProductsListManualComponent = true;
        this.displayBubbleStatus = this.commonApprovalComponent?.setWizardStatusNew(
          this.salesplanModel.projectStatuses!, this.salesplanModel.projectStatusMaster!,
          this.salesplanModel.projectApproval!
        );

        this.loadDefaultDataMapping();

        this.ngxService.stop();
      },
      error: (error) => {
        //this.msgService.htmlError('Error occured during fetch');
        this.errorLogService.logError(error, 'loadSalesplanDetails');
        this.ngxService.stop();
      },
    });
  }

  private loadDefaultDataMapping() {
    this.salesplanModel.generalInfo.salesplanDetails.orgId = this.uInfo?.orgID!;

    this.salesplanModel.generalInfo.salesplanDetails.vendorId
      = this.storageService.getItem<any>("selectedVendor").vendorID;

    this.salesplanModel.generalInfo.salesplanDetails.type = RefTypeEnum.Sales;
    this.salesplanModel.generalInfo.salesplanDetails.ctRequester = this.uInfo?.userID;
    this.salesplanModel.generalInfo.salesplanDetails.salesplanId = this.salesplanId;
  }

  onCommuncation(event: any) {
    this.reciveCoomunication = event;
  }

  onProductSelectionUpdate(event: any) {
    //alert(event);
    if (event.from == "manual") {
      this.salesplanModel.isProductManual = true;
      //this.salesplanModel.products = null;
    }
    else if (event.from == "list") {
      this.salesplanModel.isProductManual = false;
      // this.salesplanModel.productsManual = null;
    }
  }

  onUpdatePRoductRows(event: ProductListManualVm[]) {
    this.salesplanModel.productsManual = event;
    this.salesplanModel.isProductManual = true;
    this.salesplanModel.products = null;
    const hasParent = event?.some(row => row.isParentSelected);
    const childRows = event?.filter(row => !row.isParentSelected);

    // Show the message if there is no parent and only one child
    if (!hasParent && childRows.length >= 1) {
      this.msgService.htmlError("Please add at least one parent to add a child");
    }

    const isValidForAnyProduct = this.hasValidValuesInProducts(event);
    if (isValidForAnyProduct) {
      this.hasProductItems = true;
    }
    else {
      this.hasProductItems = false;
    }
  }

  hasValidValuesInProducts(products: ProductListManualVm[]) {
    return products.some(product => {
      if (!product.isItRemove && product.isManuallyAddedNewProduct) {
        return product.newProductTitle || product.vendorItemNumber || product.upc;
      } else {
        return product.product || product.vendorItemNumber || product.upc;
      }
    });
  }

  onRButtonStatus(event: any): void {
    if (event.from == "productListManual") {
      this.salesplanModel.isProductManual = true;
      this.salesplanModel.products = null;
    }
    else if (event.from == "productList") {
      this.salesplanModel.isProductManual = false;
      this.salesplanModel.productsManual = null;
    }
    else {
      this.salesplanModel.isProductManual = false;
    }
  }

  ngAfterViewInit() {
    // Query all nav-link elements inside mr-auto class and attach click event listener
    document.querySelectorAll('.mr-auto .nav-link').forEach(anchor => {
      anchor.addEventListener('click', (event) => this.onNavLinkClick(event));
    });
    // Listen to scroll events
    this.renderer.listen('window', 'scroll', () => {
      this.setActiveTabOnScroll();
    });

    //this.productsListComponent!.loadDefaultSelection(true);

    ////By Default, product selection should be manual
    this.productsListManualComponent!.loadDefaultSelection(true);
  }

  async onBubbleStatusChanged(bubleStatus: any) {
    this.loadSalesplanDetails(this.salesplanId!);
    //window.location.reload();
  }

  bubbleStatusUpdate(bubleStatus: any) {
    this.initiatedStatusClass = bubleStatus.initiated;
    this.approvedStatusClass = bubleStatus.approved;
    this.pwrLinkedStatusClass = bubleStatus.pwrlinked;
  }

  multiFileEvent(event: any) {
    if (event.target.value) {
      let totalImages = 0;
      if (this.salesplanModel.images!.logoFiles != null
        && this.salesplanModel.images!.logoFiles != undefined
        && this.salesplanModel.images!.logoFiles.length > 0
      ) {
        totalImages = this.salesplanModel.images!.logoFiles.length + event.target.files.length;
      }
      else {
        totalImages = event.target.files.length;
      }

      if (totalImages > 3) {
        this.toastr.error("Upload logo field allows upto 3 images.");
        return;
      }

      let fileTypes = [];

      for (var i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i] as File;

        if (file.type == 'image/png'
          || file.type == 'image/gif'
          || file.type == 'image/jpeg'
        ) {
        }
        else {
          fileTypes.push(file.type);
        }
      }

      if (fileTypes != null
        && fileTypes != undefined
        && fileTypes.length > 0
      ) {
        this.toastr.error("Only image files are allowed to upload in Logo section.");
        return;
      }

      if (event.target.files.length > 0) {
        var counter = 0;
        if (this.salesplanModel.images.logoFiles === null || this.salesplanModel.images.logoFiles === undefined || this.salesplanModel.images.logoFiles?.length == 0) {
          this.salesplanModel.images.logoFiles = new Array<SalesPlanImageFilesVm>;
        }
        for (var i = 0; i < event.target.files.length; i++) {
          const file = event.target.files[i] as File;

          this.changeFile(file).then((base64: any) => {
            let imageVm = new SalesPlanImageFilesVm();
            imageVm.base64Bytes = base64.substr(base64.indexOf(',') + 1);
            imageVm.imageName = file.name;
            imageVm.type = file.type;
            imageVm.tempUniqueId = this.generateUniqueId();

            this.salesplanModel.images.logoFiles?.push(imageVm);
            counter = counter + 1;
          });
        }
      }
      this.unsavedChangesService.setUnsavedChanges(true);
    }

  }

  generateUniqueId(): string {
    return uuidv4();
  }

  delItem(salesPlanImageFilesVm: SalesPlanImageFilesVm) {

    if (!this.disableAfterReview) {
      let imageIndex: number = -1;

      if (salesPlanImageFilesVm.imageID !== 0) {
        imageIndex = this.salesplanModel.images.logoFiles?.findIndex(file => file.imageID === salesPlanImageFilesVm?.imageID);

        this.confirmationService.confirm({
          header: ProjectConstants.SALESPLAN_DELETE_HEADER,
          message: ProjectConstants.SALESPLAN_DELETE_IMAGES,
          accept: () => {

            this.projectService.deleteSalesPlanImages(salesPlanImageFilesVm.salesPlanID, salesPlanImageFilesVm?.imageID, "main").subscribe(data => {

              this.salesplanModel.images.logoFiles.splice(imageIndex, 1);
              this.toastr.success(ProjectConstants.SALESPLAN_DELETE_IMAGE_SUCCESS);
            });
          }
        });
      }
      else {
        if (salesPlanImageFilesVm?.tempUniqueId !== undefined) {
          imageIndex = this.salesplanModel.images.logoFiles?.findIndex(file => file.tempUniqueId === salesPlanImageFilesVm?.tempUniqueId);
          this.salesplanModel.images.logoFiles.splice(imageIndex, 1);
        }
      }
    }
  }

  changeFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = (reader.result as string).split(',')[1]; // Remove data URL prefix
        resolve(base64);
      };
      reader.onerror = () => reject('Error reading file');
      reader.readAsDataURL(file);
    });
  }

  onNavLinkClick(event: Event) {
    event.preventDefault();

    // Remove "active" class from all nav-link elements within mr-auto
    document.querySelectorAll('.mr-auto .nav-link').forEach(link => {
      link.classList.remove('active');
    });

    // Add "active" class to the clicked element
    (event.currentTarget as HTMLElement).classList.add('active');

    const targetId = (event.currentTarget as HTMLAnchorElement).getAttribute('href')?.substring(1);
    const targetElement = document.getElementById(targetId || '');

    if (targetElement) {
      const fixedSection = document.querySelector<HTMLElement>('.fixed-section');
      const topOffset = fixedSection ? fixedSection.offsetHeight : 0;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: targetPosition - topOffset,
        behavior: 'smooth'
      });
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.setActiveTabOnScroll();
  }

  ///this code is for tp heilight the tab when scroll the page
  private setActiveTabOnScroll(): void {
    const sections = document.querySelectorAll('div[id]');
    const scrollPosition = window.scrollY + window.innerHeight / 2;
    const buffer = 10;

    let newActiveTab = 'generalInfo';

    sections.forEach((section) => {
      const element = section as HTMLElement;
      const sectionTop = element.getBoundingClientRect().top + window.scrollY - buffer;
      const sectionHeight = element.offsetHeight;
      const sectionId = section.getAttribute('id') || '';

      if ((scrollPosition >= sectionTop) && (scrollPosition < (sectionTop + sectionHeight + buffer))) {
        newActiveTab = sectionId;
      }
    });
    if (newActiveTab !== this.activeTab) {
      this.activeTab = newActiveTab;
    }
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  onChangeAddProductCategoryID(value: number | null | undefined) {
    this.selectedNewProductCategoryId = value;

  }

  // Function to check if at least one item has any of the specified properties empty or is true with empty newProductTitle
  hasEmptyRequiredPropertiesForNewProduct(products: ProductListManualVm[]): boolean {
    return products.some(product =>
      (!product.upc ||
        !product.vendorItemNumber || !product.newProductTitle) &&
      (product.isManuallyAddedNewProduct === true) && (product.isItRemove == false)
    );
  }

  // Function to assign selectedNewProductCategoryId to all items in productsManual using map
  assignCategoryToProducts(salesPlanModel: SalesPlanVm) {
    // Check if productsManual is not null and selectedNewProductCategoryId is defined
    if (salesPlanModel.productsManual && this.selectedNewProductCategoryId !== undefined) {
      salesPlanModel.productsManual = salesPlanModel.productsManual.map(product => ({
        ...product,
        categoryID: this.selectedNewProductCategoryId !== null
          ? this.selectedNewProductCategoryId
          : 0 // Explicitly set to undefined if null
      }));
    }
  }

  async loadProducts() {
    this.masterService.getProductsByCategories(this.allCategories).subscribe({
      next: (result) => {
        this.orgProductsList = []
        this.orgProductsList = result;
      },
      error: (error) => this.handleError('Error occurred while fetching products.', error),
    });
  }

  getAddProjectResult(productsManual: ProductListManualVm[] | null): InstallationProductResultDto[] {
    if (!productsManual || productsManual.length === 0) {
      return [];
    }

    const manuallyAddedNewProducts = productsManual
      .filter(x => x.isManuallyAddedNewProduct === true && x.productID === 0);

    const manuallyAddedProducts = productsManual
      .filter(x => x.isManuallyAddedNewProduct === true && x.productID !== undefined && x.productID > 0);

    const allProducts = this.orgProductsList;

    const lstInstallationProductResultDto: InstallationProductResultDto[] = [];

    // Process manually added new products
    if (manuallyAddedNewProducts.length > 0) {
      const newProductResults = manuallyAddedNewProducts
        .filter(product => product.vendorItemNumber)
        .map(manual => {
          const matchedProduct = allProducts.find(dto =>
            dto.vendorItemNumber?.trim().toLowerCase() === manual.vendorItemNumber?.trim().toLowerCase()
          );

          if (matchedProduct) {
            return {
              productDesc: manual.newProductTitle,
              itemNumber: manual.vendorItemNumber,
              upc: manual.upc
            };
          }
          return null;
        })
        .filter(result => result !== null) as InstallationProductResultDto[];

      lstInstallationProductResultDto.push(...newProductResults);
    }

    // Process manually added existing products
    if (manuallyAddedProducts.length > 0) {
      manuallyAddedProducts.forEach(item => {
        const product = allProducts.find(x => x.productID === item.productID);
        if (product && item.vendorItemNumber !== product.vendorItemNumber) {
          const existingProductResult = allProducts.find(dto =>
            dto.vendorItemNumber?.trim().toLowerCase() === item.vendorItemNumber?.trim().toLowerCase()
          );

          if (existingProductResult) {
            lstInstallationProductResultDto.push({
              productDesc: item.newProductTitle,
              itemNumber: item.vendorItemNumber,
              upc: item.upc
            });
          }
        }
      });
    }

    return lstInstallationProductResultDto;
  }

  private handleError(message: string, error: any): void {
    this.msgService.htmlError(message);
    this.errorLogService.logErrorNew(message, error);
    //this.ngxService.stop();
  }

  //// Ready for review changes 
  KeyValueChangesAfterReviewRequest(e: string) {
    if (this.ginfoSpKeyDatesComponent) {

      this.ginfoSpKeyDatesComponent.changeKeyDatesAfterReviewRequest(this.salesplanModel.headerId);
    }
  }

  getProductsByCategories() {
    this.masterService.getProductsByCategories(this.selectedCategories).subscribe(res => {
      if (res) {
        this.productItems = [];
        this.productItems = res;
      }
    });
  }

  onProductReviewConfirmation(event: any) {
    this.salesplanModel.isProductReviewConfirmed = event;
  }

  //// Call this ReadyForReview method to check validation before reviewing
  async ReadyForReview(e: string) {
    const isValidSalesPlanData = await this.validateSalesPlanData(true);
    if (isValidSalesPlanData) {
      this.commonApprovalComponent!.readyForReviewClick();
    }
  }

  addItemReviewLogs() {
    if (this.hasProductItems) {
      // Show confirmation dialog to the user for Product Review
      this.confirmationService.confirm({
        header: "Products Dialog",
        icon: 'pi pi-exclamation-triangle',
        message: "Have you reviewed the product items to ensure they are accurate?",

        accept: () => {
          let reviewLog = new ReviewLog();
          reviewLog.refID! = this.salesplanId!;
          reviewLog.type = this.refType;
          reviewLog.reviewedFor = 'Product';
          reviewLog.reviewedBy = this.uInfo?.userEmail;

          this.projectService.addItemReviewLogs(reviewLog).subscribe(x => {
            this.msgService.htmlSuccess("Product items are reviewed successfully");
            this.productReviewedBy = this.uInfo?.userEmail!;
            const currentDate = new Date();
            this.productReviewedDate = currentDate;
          });
        },
        reject: () => {
        }
      });
    }
  }

  deleteProductByCategory(categoryId: number) {
    this.projectService.deleteProductByCategory(this.salesplanId, "SalesPlan", categoryId).subscribe({
      next: async (data: any) => {
        if (data) {
          this.salesplanModel.productsManual = this.salesplanModel.productsManual!.filter(x => x.categoryID != categoryId);
          this.salesplanModel.selectedCategories = this.selectedCategories;
          // this.loadProjectDetails(this.projectId);
          this.finalSalesPlanSave();
        }
      }
    })
  }

  deleteProject() {
    this.projectService.deleteProjects(this.salesplanModel.headerId, "SalesPlan").subscribe({
      next: async (data: any) => {
        if (data) {
          this.router.navigate(['/manage-salesplan']);
        }
      }
    })

  }

  cancelProject() {
    if (this.salesplanId > 0) {
      this.confirmationService.confirm({
        header: ' ',
        icon: 'pi pi-exclamation-triangle',
        message: "This action cannot be reversed. Are you sure to delete the SalesPlan?",
        accept: () => {
          this.deleteProject();
        },
        reject: () => {
          return;
        }
      })
    }
  }

  showLogoLibraryPopup() {
    this.selectedImages = [];
    this.showModalPopup = true;
    setTimeout(() => {
      $('#logoModal').modal("show");
    }, 500);
  }

  closeLogoLibraryPopup() {
    $('#logoModal').modal("hide");
    this.showModalPopup = false;
    this.selectedImages = [];
  }

  // Method to check if an image is selected
  isImageSelected(image: any): boolean {
    return this.selectedImages.includes(image);
  }

  onLogoImageSelect(event: Event, image: any): void {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      this.selectedImages.push(image); // Add image to selected list
    } else {
      // Remove image from the selected list
      this.selectedImages = this.selectedImages.filter(
        (selected) => selected !== image
      );
    }
  }

  submitSelectedImages(): void {
    if (this.selectedImages.length > 3) {
      this.toastr.error("Upload logo field allows upto 3 images.");
      return;
    }

    var totalImages = 0;

    if (this.salesplanModel.images!.logoFiles != null
      && this.salesplanModel.images!.logoFiles != undefined
      && this.salesplanModel.images!.logoFiles.length > 0
    ) {
      totalImages = this.salesplanModel.images!.logoFiles.length + this.selectedImages.length;
    }

    if (totalImages > 3) {
      this.toastr.error("Upload logo field allows upto 3 images.");
      return;
    }

    if (totalImages == 0) {
      this.salesplanModel.images.logoFiles = new Array<SalesPlanImageFilesVm>;
    }

    this.selectedImages.forEach((selectedImage, index) => {
      const imageVm = new SalesPlanImageFilesVm();
      imageVm.base64Bytes = selectedImage.imageBase64String;
      imageVm.imageName = selectedImage.imageName;
      imageVm.type = this.getFileType(selectedImage.imageName);
      imageVm.tempUniqueId = this.generateUniqueId();

      this.salesplanModel.images.logoFiles.push(imageVm);
    });

    this.closeLogoLibraryPopup();
  }

  private getFileType(base64: string): string {
    const match = base64.match(/^data:(.*);base64,/);
    return match ? match[1] : 'unknown';
  }

  allSelected: boolean = false;

  toggleSelectAll(event: any) {
    this.allSelected = event.checked; // Get checkbox state

    if (this.allSelected) {
      this.selectedCategories = this.categoryList.map(c => c.value); // Select all categories
    } else {
      this.selectedCategories = []; // Deselect all
    }
  }

  cloneSalesPlan() {

    if (this.clonedProjectTitle == '') {
      this.msgService.htmlError(ProjectConstants.SALESPLAN_CLONE_EVENTTITLE_REQUIRED);
      return;
    }

    if (this.salesplanOriginal.salesplanId > 0) {
      this.confirmationService.confirm({
        header: ' ',
        icon: 'pi pi-exclamation-triangle',
        message: "Are you sure to clone the Sales Plan?",
        accept: () => {
          const newSalesPlan = this.cloneSalesPlanForNewEntry(this.salesplanOriginal);
          this.salesplanModel = newSalesPlan;
          this.finalSalesPlanSave(true);
        },
        reject: () => {
          return;
        }
      })
    }
  }

  cloneSalesPlanForNewEntry(salesPlan: any): any {

    const clone = JSON.parse(JSON.stringify(salesPlan));

    clone.refProjectId = clone.salesplanId;

    // Reset top-level IDs
    clone.headerId = 0;
    clone.salesplanId = 0;

    // Update project title
    clone.generalInfo.salesplanDetails.projectTitle = this.clonedProjectTitle;

    // Set initiatedDate to current date
    // Assign the Start Date and End Date based on the initiatedDate
    const currentDate = new Date();

    // Assign the current date
    clone.generalInfo.keyDates.initiatedDate = currentDate;

    // Assign formatted string version
    clone.generalInfo.keyDates.initiatedDateStr = this.datePipe.transform(currentDate, 'dd-MMM-yyyy');

    //Referred the same in ginfo-salesplan-keydates
    clone.generalInfo.keyDates.startDate = this.getFutureSunday();
    const momentDate = moment(clone.generalInfo.keyDates.startDate, 'YYYY-MM-DD').toDate();
    clone.generalInfo.keyDates.startDate = momentDate;
    clone.generalInfo.keyDates.startDateStr = moment(clone.generalInfo.keyDates.startDate).format('DD-MMM-yyyy');

    let selectedStartDate = new Date(clone.generalInfo.keyDates.startDate);

    // Create a new Date object for adjusting
    const tWOWeeksLater = new Date(selectedStartDate);
    tWOWeeksLater.setDate(selectedStartDate.getDate() + (7 * 2)); // Adjusting the date by 14 days

    // Set the end date in the keyDatesInfo
    clone.generalInfo.keyDates.endDate = tWOWeeksLater;
    const momentEndDate = moment(clone.generalInfo.keyDates.endDate, 'YYYY-MM-DD').toDate();
    clone.generalInfo.keyDates.endDate = momentEndDate;
    clone.generalInfo.keyDates.endDateStr = moment(clone.generalInfo.keyDates.endDate).format('DD-MMM-yyyy');

    // For MABD Date
    if (clone.generalInfo.salesplanDetails.mabd !== null) {
      const momentMABDDate = moment(clone.generalInfo.salesplanDetails.mabd, 'YYYY-MM-DD').toDate();
      clone.generalInfo.salesplanDetails.mabd = momentMABDDate;
      clone.generalInfo.salesplanDetails.madbStr = moment(clone.generalInfo.salesplanDetails.mabd).format('DD-MMM-yyyy');
    }

    // Clear image IDs
    if (clone.images) {
      clone.images.imageFiles?.forEach((img: any) => {
        img.imageID = 0;
        img.salesPlanID = 0;
      });

      clone.images.logoFiles?.forEach((logo: any) => {
        logo.imageID = 0;
        logo.salesPlanID = 0;
      });
    }

    if (clone.generalInfo?.salesplanDetails) {
      clone.generalInfo.salesplanDetails.salesplanId = 0;
    }

    // Reset product flow internal mapping if exists
    if (clone.generalInfo?.salesplanDetails?.productFLowList) {
      clone.generalInfo.salesplanDetails.productFLowList.forEach((flow: any) => {
        delete flow.salesplanProductFlowID;
        delete flow.salesPlanID;
      });
    }

    // Reset product file references
    if (clone.products) {
      clone.products.projectFileID = 0;
      clone.products.refID = 0;
      clone.products.fileIndexID = null;
      clone.products.filePath = "";
      clone.products.fileChanged = true;
      clone.products.createdDate = new Date().toISOString();

      clone.isProductManual = false;
      clone.productsManual = null;
    }

    if (clone.productsManual) {
      clone.isProductManual = true;
    }

    let actualStoreNumbers = '';

    // Reset store list file references
    if (clone.generalInfo?.storeListManual) {
      clone.generalInfo.storeListManual.projectFileID = 0;
      clone.generalInfo.storeListManual.refID = 0;
      clone.generalInfo.storeListManual.fileIndexID = null;
      clone.generalInfo.storeListManual.filePath = "";
      clone.generalInfo.storeListManual.createdDate = new Date().toISOString();
      actualStoreNumbers = clone.generalInfo.storeListManual.storeNumbers;
    }

    if (clone.generalInfo?.storeList) {
      clone.generalInfo.storeList.projectFileID = 0;
      clone.generalInfo.storeList.refID = 0;
      clone.generalInfo.storeList.fileIndexID = null;
      clone.generalInfo.storeList.fileChanged = true;
      clone.generalInfo.storeList.createdDate = new Date().toISOString();
      actualStoreNumbers = clone.generalInfo.storeList.storeNumbers;
    }

    // Reset project statuses
    clone.requestor = this.loggedInUserID;
    clone.projectStatuses = [];
    clone.projectStatus = {
      statusID: 1,
      changedBy: clone.requestor,
      type: "SalesPlan",
      isApproved: false
    };
    clone.salesPlanStatus = {};
    clone.projectApproval = null;
    clone.productsReviewLog = [];
    clone.isProductReviewConfirmed = false;

    // Reset top-level IDs again if referenced elsewhere
    clone.projectApproval = {
      approvalID: 0,
      refID: 0
    };

    // Reset IDs inside projectStatus if present
    if (clone.projectStatus) {
      clone.projectStatus.projectStatusID = 0;
      clone.projectStatus.refID = 0;
    }

    // Reset misc flags and values
    clone.salesPlanStatus = {};

    clone.orgID = this.orgID;
    clone.vendorId = this.storageService.getItem<any>("selectedVendor").vendorID;

    // Clone the Existing Hawaii stores matching with the actual stores
    if(this.salesplanModel.identifiedStores !== null && this.salesplanModel.identifiedStores !== '' && actualStoreNumbers !== ''){

      const actualArray = actualStoreNumbers.split(",").map(s => s.trim()).filter(s => s);
      const identifiedArray = this.salesplanModel.identifiedStores.split(",").map(s => s.trim()).filter(s => s);

      const commonStores = actualArray.filter(num => identifiedArray.includes(num));
      const commonStoresToIdentify = commonStores.join(",");

      clone.identifiedStores = "";
      clone.storesToIdentify = commonStoresToIdentify;
    }

    return clone;
  }

  getFutureSunday(): Date {
    const baseDate = new Date();
    const threeWeeksLater = new Date(baseDate);
    threeWeeksLater.setDate(baseDate.getDate() + 21); // Add 21 days (3 weeks)

    // Find the immediate Sunday after three weeks later
    const dayOfWeek = threeWeeksLater.getDay();
    const daysUntilSunday = (7 - dayOfWeek) % 7;
    const nextSunday = new Date(threeWeeksLater);
    nextSunday.setDate(threeWeeksLater.getDate() + daysUntilSunday);

    return nextSunday;
  }

  getStoresToIdentify(
    allHawaiiStores: string | null | undefined,
    givenStores: string | null | undefined,
    identifiedStores: string | null | undefined
  ): string {
    // Default to empty arrays if inputs are null/undefined/empty
    const allHawaiiArr = (allHawaiiStores || '')
      .split(',')
      .map(s => s.trim())
      .filter(s => s); // remove empty strings

    const givenArr = (givenStores || '')
      .split(',')
      .map(s => s.trim())
      .filter(s => s);

    const identifiedArr = (identifiedStores || '')
      .split(',')
      .map(s => s.trim())
      .filter(s => s);

    if (!allHawaiiArr.length || !givenArr.length) {
      return ''; // nothing to match
    }

    // Filter to stores that are in given list & Hawaii list
    const matchingStores = givenArr.filter(store => allHawaiiArr.includes(store));

    //Remove any that are already identified
    const storesToIdentify = matchingStores.filter(store => !identifiedArr.includes(store));

    // Step 3: Return as comma-separated string
    return storesToIdentify.join(',');
  }

  //Get all stores in Hawaii state
  private getStoresByStates() {
    let selectedState = ["HI"];
    this.projectService.getStoresByStates(Number(this.vendorId), selectedState).subscribe(x => {
      this.selectedStoresByStates = x;
    });
  }

  onNotifyIsoAdmin(e: string) {

    if (this.salesplanId > 0) {

      const storeNumbers = e;

      const numbersArr = storeNumbers.split(',').map(x => x.trim());
      const storeDetails = this.selectedStoresByStates.filter(store => numbersArr.includes(store.storeNumber));
      this.salesplanModel.selectedStoresByStates = storeNumbers;

      const existingStores = this.salesplanModel.identifiedStores
        ? this.salesplanModel.identifiedStores.split(',').map(s => s.trim())
        : [];

      const newStores = storeNumbers.split(',').map(s => s.trim());

      // Merge and remove duplicates
      const updatedStores = Array.from(new Set([...existingStores, ...newStores]));

      const project: ProjectDto = {
        projectID: this.salesplanId,
        vendorID: Number(this.vendorId),
        projectTitle: this.salesplanModel.generalInfo.salesplanDetails.projectTitle,
        projectType: RefTypeEnum.Sales,
        userID: this.salesplanModel.generalInfo.salesplanDetails.ctRequester,
        categoryList: this.selectedCategories,
        stores: storeDetails
      };

      const emailRequest: EmailRequestDto = {
        emailPurposeID: 6,
        purpose: EmailPurpose[6],
        toEmail: '',
        subject: '',
        placeholders: {},
        htmlBody: '',
        ccList: [],
        bccList: [],
        project: project,
        notes: storeNumbers
      };

      this.ngxService.start();

      this.emailService.sendEmail(emailRequest).pipe(
        finalize(() => {
          this.ngxService.stop();
        })
      ).subscribe(
        (isEmailSent: boolean) => {
          if (isEmailSent) {
            this.isNotifiedForStoreIdentificaion = true;
            this.salesplanModel.identifiedStores = updatedStores.join(', ');
            this.selectedIdentifiedStoreNumbers = updatedStores.join(', ');
            this.msgService.htmlSuccess(ProjectConstants.STORE_NOTIFICATION_MSG);
          } else {
            this.msgService.htmlError('Email could not be sent.');
          }
        },
        (error) => {
          this.msgService.htmlError('An error occurred while sending the email.');
        }
      );
    }
    else {
      this.msgService.htmlError(ProjectConstants.PROJECT_SALESPLAN_NOPROJECT);
      return;
    }
  }

  isAnyChangesOnStoreNumbers(existingStoreNumbers: string, currentStoreNumbers: string): boolean {
    if (!existingStoreNumbers && !currentStoreNumbers) {
      return false;
    }

    const normalize = (stores: string) =>
      Array.from(
        new Set(
          (stores || '')
            .split(',')
            .map(s => s.trim())
            .filter(s => s) // remove empty strings
        )
      )
        .sort()
        .join(',');

    const normalizedExisting = normalize(existingStoreNumbers);
    const normalizedCurrent = normalize(currentStoreNumbers);

    return normalizedExisting !== normalizedCurrent;
  }

}
